import React, { useState } from "react";
import {
  View,
  Text,
  TouchableOpacity,
  Image,
  TouchableWithoutFeedback,
  Platform,
} from "react-native";
import Ionicons from "@react-native-vector-icons/ionicons/static";
import { useTranslation } from "react-i18next";
import { useNavigation } from "@react-navigation/native";
import { useTheme } from "@react-navigation/native";
import Swal from "sweetalert2";
import { useAccountContext } from "../../hooks/useAccountContext";
import { DEFAULTPROFILE } from "../../img/DefaultProfile";
import { useAuthContext } from '../../hooks/useAuthContext';

const AccountDropdown = () => {
  const [showDropdown, setShowDropdown] = useState(false);
  const { account } = useAccountContext();
  const { colors } = useTheme();
  const navigation = useNavigation();
  const { dispatch } = useAuthContext();
  const { t } = useTranslation();

  const handleLogout = () => {
    if (Platform.OS === "web") {
      //* Note: below styles do not seem to be working. Maybe investigate?
      Swal.fire({
        title: `<text style="font-family:'Roboto-Medium', font-size:16px">Are you sure you want to sign out?</text>`,
        icon: "warning",
        showCancelButton: true,
        reverseButtons: true,
        cancelButtonText: `<text style="font-family:'Roboto-Medium', font-size:16px">Cancel</text>`,
        cancelButtonColor: "#d3d3d3",
        confirmButtonText: `<text style="font-family:'Roboto-Medium', font-size:16px">Sign Out</text>`,
        confirmButtonColor: "#A0A2FF",
      }).then((result) => {
        if (result.isConfirmed) {
          dispatch({ type: "LOGOUT" });
        }
      });
    } else {
      CustomAlert(
        "Are you sure you want to sign out?",
        '',
        [
          {
            text: "Cancel",
            style: "cancel",
          },
          {
            text: "Sign Out",
            onPress: () => dispatch({ type: "LOGOUT" }),
          },
        ],
        { cancelable: true }
      );
    }
  };

  return (
    <TouchableWithoutFeedback onPress={() => setShowDropdown(false)}>
      <View style={{ padding: 16, overflow: "visible" }}>
        <View style={{ flexDirection: "row", alignItems: "center" }}>
          {account !== null ? (
            <>
              <Image
                style={{
                  width: 30,
                  height: 30,
                  flexDirection: "row",
                  borderRadius: 100,
                  borderWidth: 1,
                  aligItem: "center",
                  right: 5,
                }}
                source={{
                  uri: `data:image/png;base64,${account.photograph === "" ||
                    account.photograph === undefined
                    ? DEFAULTPROFILE
                    : account.photograph
                    }`,
                }}
              />{" "}
              <Text style={{ marginHorizontal: 10 }}>{account.name}</Text>
            </>
          ) : null}

          <TouchableOpacity onPress={() => setShowDropdown((prev) => !prev)}>
            <Ionicons name="chevron-down-outline" size={20} color="black" />
          </TouchableOpacity>
        </View>

        {showDropdown && (
          <TouchableWithoutFeedback onPress={() => setShowDropdown(false)}>
            <View
              style={{
                backgroundColor: colors.background_dropdown,
                borderRadius: 10,
                borderWidth: 2,
                borderColor: "#e8e8e8",
                padding: 10,
                top: 50,
              }}
            >

              <TouchableOpacity
                onPress={() => {
                  setShowDropdown(false);
                  navigation.navigate("MyAccountScreen");
                }}
                style={{ marginHorizontal: 10, marginVertical: 10 }}
              >
                <View style={{ flexDirection: "row", alignItems: "center" }}>
                  <Image
                    style={{
                      width: 30,
                      height: 30,
                      flexDirection: "row",
                      borderRadius: 100,
                      borderWidth: 1,
                      aligItem: "center",
                      right: 5,
                    }}
                    source={{
                      uri: `data:image/png;base64,${account === null
                        ? DEFAULTPROFILE
                        : account.photograph === "" ||
                          account.photograph === undefined
                          ? DEFAULTPROFILE
                          : account.photograph
                        }`,
                    }}
                  ></Image>
                  <Text style={{ fontSize: 14, color: "#000000" }}>
                    My Profile
                  </Text>

                  <TouchableOpacity
                    onPress={() => setShowDropdown(false)}
                    style={{ marginLeft: 30 }}
                  >
                    <Ionicons
                      name="chevron-up-outline"
                      size={20}
                      color="black"
                    />
                  </TouchableOpacity>
                </View>
              </TouchableOpacity>
              <TouchableOpacity
                onPress={() => {
                  setShowDropdown(false);
                  navigation.navigate("SettingsScreen");
                }}
                style={{ marginHorizontal: 10, marginVertical: 10 }}
              >
                <View style={{ flexDirection: "row", alignItems: "center" }}>
                  <Ionicons name="language-outline" size={22} />
                  <Text style={{ paddingVertical: 6 }}> Settings </Text>
                </View>
              </TouchableOpacity>

              <TouchableOpacity
                style={{ marginHorizontal: 10, marginVertical: 10 }}
                onPress={handleLogout}
              >
                <View style={{ flexDirection: "row", alignItems: "center" }}>
                  <Ionicons name="exit-outline" size={22} />
                  <Text style={{ marginLeft: 5 }}>Sign Out</Text>
                </View>
              </TouchableOpacity>
            </View>
          </TouchableWithoutFeedback>
        )}
      </View>
    </TouchableWithoutFeedback>
  );
};

const makeStyles = (colors, height, width) =>
  StyleSheet.create({
    overlay: {
      position: "absolute",
    },
  });

export default AccountDropdown;
